import React from 'react';

const GravadoraContext = React.createContext();

export default GravadoraContext;